import './CalendarHeaderDate.scss';
import { useTranslation } from 'react-i18next';
import { dates as months } from '../../../constants/dates';
import { STD_CAL_TIMEZONE } from '../../../constants/myBlockMonth';
import { useMyBlockMonthProvider } from '../../../providers/MyBlockMonthProvider';


const CalendarHeaderDate = ({noData, searchDate, stripView}) => {
    const myBlockMonthContext = useMyBlockMonthProvider();
    const { t } = useTranslation();

    const getPilotsBaseTimezone = () => {
        const timezone = myBlockMonthContext.myBlockMonthData.blockList?.timezone;
        if(timezone) {
            if(timezone.startsWith('C')) return STD_CAL_TIMEZONE.CENTRAL;
            if(timezone.startsWith('E')) return STD_CAL_TIMEZONE.EASTERN;
            if(timezone.startsWith('P')) return STD_CAL_TIMEZONE.PACIFIC;
        }
        return '';
    }

    return (
        <div className="c-calendar-header-date">
            <div className="c-month-details">
                <p className="month-details__month">
                    {searchDate.month ? months[searchDate.month - 1].toLowerCase().charAt(0).toUpperCase() + months[searchDate.month - 1].toLowerCase().slice(1) : ' '} {searchDate.year ? searchDate.year : ' '}
                </p>
                {myBlockMonthContext.myBlockMonthData.blockDates?.days && (
                    <p className="month-details__days">
                        {`(${myBlockMonthContext.myBlockMonthData.blockDates?.days} ${t('myBlockMonth.stripCalendarHeader.days')})`}
                    </p>
                )}
            </div>
            {!noData && (
                <div className="c-time-details">
                    <p className="time-details__lbl">{t('myBlockMonth.time')}</p>
                    {stripView 
                        ? <p className="time-details__place">{t('myBlockMonth.placeOfEvent')}</p> 
                        : <p className="time-details__place">{getPilotsBaseTimezone()}</p>
                    }
                </div>
            )}
        </div>
    )
}

export default CalendarHeaderDate;